var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgList = function SvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 17a2 2 0 1 1 0 4 2 2 0 0 1 0-4M23 18a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2zM2 10a2 2 0 1 1 0 4 2 2 0 0 1 0-4M23 11a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2zM2 3a2 2 0 1 1 0 4 2 2 0 0 1 0-4M23 4a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2z"
  })));
};
export default SvgList;